let suggestedDevelopments = (function () {
    let developments = [];

    const init = async function () {

        let refreshRequired = true;
        let lastRefreshed = sessionStorage.getItem("lastRefreshed");
        let storedDevelopments = sessionStorage.getItem("developments");

        if ( lastRefreshed && storedDevelopments && isValidJSON(storedDevelopments) ) {
          let timeDiff = Date.now() - lastRefreshed;
          // if time diff greater than 15 mins (900000ms) refresh the data
          if ( timeDiff < 9000000 ) {
            refreshRequired = false;
          }
        }
        
        if (refreshRequired) {
          loadData().then( (updatedDevelopments) => {
            developments = updatedDevelopments;
            sessionStorage.setItem("developments", JSON.stringify(updatedDevelopments));
            sessionStorage.setItem("lastRefreshed", Date.now());
          }).catch( (err) => {
            sessionStorage.removeItem("lastRefreshed");
            sessionStorage.removeItem("developments");
          });
        } else {
            developments = JSON.parse(storedDevelopments);
        }
    };

    const isValidJSON = function (obj) {
      try {
        JSON.parse(obj);
        return true;
      } catch (e) {
        return false;
      }
    };

    const loadData = async function () {
      try {
        let suggestions = [];
        let response = await fetch(`${APIPrefix.get()}/search_api/developments/suggestions`);
        if (response.status === 200) {
          let data = await response.json();
          suggestions = data.data.items.sort((a, b) => {
            const nameA = a.name.toUpperCase(); 
            const nameB = b.name.toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
          
            // names must be equal
            return 0;
          });
          // create a key to match on, hyphen ensures that match will be within name or location, and not spanning them
          suggestions = suggestions.map(obj => ({ ...obj, key: `${getSearchKey(obj.name)}-${getSearchKey(obj.location)}` }));
          return suggestions;
        } else {
          throw new Error(response.status);
        }
      } catch (error) {
        throw new Error(error);
      }
    };

    const getSuggestions = function (location) {
        const locationKey = getSearchKey(location);
        const result = developments.filter(development => development.key.includes(locationKey) );
        return result;
    };

    const getSearchKey = function (searchString) {
        return searchString.replace(/[^1-9a-zA-Z]/g,'').toLowerCase();
    };

    return {
        init: init,
        getSuggestions: getSuggestions
    };

})();